import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import FormHelperText from "@mui/material/FormHelperText";
import Button from "@mui/material/Button";
import FormLabel from "@mui/material/FormLabel";
import Tooltip from "@mui/material/Tooltip";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import moment from "moment";
//bootstrap input mui
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
//paper mui
import Typography from "@mui/material/Typography";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Radio from "@mui/material/Radio";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import "./ToolBox.css";
import { useRef } from "react";
import IconButton from "@mui/material/IconButton";
import { Verified } from "@mui/icons-material";
import theme from "../../../Theme";
const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: "",
    border: "1px solid #ced4da",
    fontSize: 12,
    width: "100",
    padding: "2px 5px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    // Use the system font instead of the default Roboto font.
    // fontFamily: [
    //     '-apple-system',
    //     'BlinkMacSystemFont',
    //     '"Segoe UI"',
    //     'Roboto',
    //     '"Helvetica Neue"',
    //     'Arial',
    //     'sans-serif',
    //     '"Apple Color Emoji"',
    //     '"Segoe UI Emoji"',
    //     '"Segoe UI Symbol"',
    // ].join(','),
    "&:focus": {
      boxShadow: `unset`,
      borderColor: theme.palette.primary.main,
    },
  },
}));
export const CmpSelectFieldV1 = ({
  xSize = "small",
  xLabelText,
  xValue,
  xOnChange = () => {},
  xName,
  xData = [],
  xValueMember = "",
  xDispalyMember = "",
  xError = false,
  xErrorMessage = false,
  xDisable = false,
  xOnkeyUp,
  xtabIndex = "",
  xref = "",
  xonFocus,
  xonBlur,
  salespaddingReduce = false,
}) => {
  const fTextFieldDummy = (e) => {};
  const inputReference = useRef(null);
  return (
    <FormControl fullWidth className="LocSelectionStyle" disabled={xDisable}>
      <InputLabel
        id="demo-simple-select-label"
        sx={{
          color: "primary.main", // Apply red when disabled, primary color otherwise
          top: "-7px", // Adjust label position
          "&.MuiInputLabel-shrink": {
            top: "0px", // When a value is selected
          },
          "&.Mui-disabled": {
            color: "primary.main", // Ensure focus color matches
          },
        }}
      >
        {xLabelText}
      </InputLabel>
      <Select
        inputProps={{ tabIndex: xDisable ? "" : xtabIndex }}
        inputRef={xref ? xref : inputReference}
        className={xDisable ? "disable-color test " : "test var(--primary)"}
        value={!!xValue ? xValue : ""}
        label={xLabelText}
        onChange={!!xOnChange ? xOnChange : fTextFieldDummy}
        onFocus={!!xonFocus ? xonFocus : fTextFieldDummy}
        onBlur={!!xonBlur ? xonBlur : fTextFieldDummy}
        name={xName}
        fullWidth
        onKeyUp={!!xOnkeyUp ? xOnkeyUp : fTextFieldDummy}
        // style={{ height: '2.3rem' }}
        // input={<BootstrapInput />}
        size={xSize}
        error={xError}
        sx={{
          lineHeight: "1em", // Updated line-height
        }}
        // helperText={xErrorMessage}
      >
        {xData.length > 0 ? (
          xData?.map((e, i) => {
            const keys = Object.keys(e);
            return (
              <MenuItem className="menuSm" key={"Key" + i} value={e[keys[0]]}>
                {e[keys[1]]}
              </MenuItem>
            );
          })
        ) : (
          <MenuItem value={""}>none</MenuItem>
        )}
      </Select>
      {xError ? (
        <FormHelperText className="text-danger">{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </FormControl>
  );
};
export const CmpSelectArrFieldV1 = ({
  xSize = "small",
  xLabelText,
  xValue,
  xOnChange = () => {},
  xName,
  xData = [],
  xValueMember = "",
  xDispalyMember = "",
  xError = false,
  xErrorMessage = false,
  xDisable = false,
  xOnkeyUp,
  xtabIndex = "",
  xref = "",
  xonFocus,
  xonBlur,
  salespaddingReduce = false,
}) => {
  const fTextFieldDummy = (e) => {};
  const inputReference = useRef(null);
  return (
    <FormControl fullWidth className="LocSelectionStyle" disabled={xDisable}>
      <InputLabel
        id="demo-simple-select-label"
        sx={{
          color: "primary.main", // Apply red when disabled, primary color otherwise
          top: "-7px", // Adjust label position
          "&.MuiInputLabel-shrink": {
            top: "0px", // When a value is selected
          },
          "&.Mui-disabled": {
            color: "primary.main", // Ensure focus color matches
          },
        }}
      >
        {xLabelText}
      </InputLabel>
      <Select
        inputProps={{ tabIndex: xDisable ? "" : xtabIndex }}
        inputRef={xref ? xref : inputReference}
        className={xDisable ? "disable-color test " : "test "}
        value={!!xValue ? xValue : ""}
        label={xLabelText}
        onChange={!!xOnChange ? xOnChange : fTextFieldDummy}
        onFocus={!!xonFocus ? xonFocus : fTextFieldDummy}
        onBlur={!!xonBlur ? xonBlur : fTextFieldDummy}
        name={xName}
        fullWidth
        onKeyUp={!!xOnkeyUp ? xOnkeyUp : fTextFieldDummy}
        // style={{ height: '2.3rem' }}
        // input={<BootstrapInput />}
        size={xSize}
        error={xError}
        sx={{
          lineHeight: "1em", // Updated line-height
        }}
        // helperText={xErrorMessage}
      >
        {xData.length > 0 ? (
          xData?.map((e, i) => {
            return (
              <MenuItem key={"Key" + i} value={e}>
                {e}
              </MenuItem>
            );
          })
        ) : (
          <MenuItem value={""}>none</MenuItem>
        )}
      </Select>
      {xError ? (
        <FormHelperText className="text-danger">{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </FormControl>
  );
};
export const CmpTextFieldEnterV1 = ({
  xLabelText,
  xVariant,
  xValue,
  xOnChange,
  xReadOnly = false,
  xType,
  xName,
  xOnKeyUp,
  xError,
  xErrorMessage,
  xonFocus,
  xonBlur,
  xOnEnter,
  xSmShow,
  xref = "",
  xtabIndex = "",
  xSize = "",
  xId = "",
  xDisabled = false,
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <div className="d-flex TextFieldEnter">
      <TextField
        size={xSize}
        id={xId}
        inputProps={{ tabIndex: xtabIndex }}
        inputRef={xref ? xref : inputReference}
        label={xLabelText}
        variant={xVariant} //"standard/outlined/filled"
        value={xValue}
        disabled={xDisabled}
        type={xType} // text/number/password
        name={xName}
        InputProps={{
          readOnly: xReadOnly,
        }}
        onChange={(e) => {
          xOnChange(e);
        }}
        onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
        onFocus={!!xonFocus ? xonFocus : fTextFieldDummy}
        onBlur={!!xonBlur ? xonBlur : fTextFieldDummy}
        fullWidth
        error={xError}
        helperText={xErrorMessage}
        autoComplete="off"
      />
      {xSmShow ? (
        <>
          <Button
            variant="contained"
            className={xError ? "px-0 enter-btn  mb-4" : "px-0 enter-btn "}
            onClick={!!xOnEnter ? xOnEnter : fTextFieldDummy}
          >
            <ArrowForwardOutlinedIcon />
          </Button>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export const CmpDatePickerField001V1 = ({
  xValue,
  xOnChange,
  xName,
  xError = false,
  xErrorMessage = false,
  xOnKeyUp,
  xtabIndex = "",
  xref = "",
  xmindate = "",
  xDisable = false,
  xmaxdate = "",
  xLabelText = "",
}) => {
  const fTextFieldDummy = (e) => {};
  const inputReference = useRef(null);
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      // className="CmpDatePickerField-v1"
    >
      <DatePicker
        label={xLabelText}
        disabled={xDisable}
        inputFormat="DD/MM/YYYY"
        value={xValue}
        onChange={!!xOnChange ? xOnChange : fTextFieldDummy}
        onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
        inputProps={{
          tabIndex: xtabIndex,
        }}
        inputRef={xref ? xref : inputReference}
        renderInput={(params) => (
          <TextField
            {...params}
            name={xName}
            size="small"
            fullWidth
            autoComplete="off"
            // InputLabelProps={{
            //   sx: {
            //     color: "primary.main",
            //     "&.Mui-disabled": {
            //       color: "primary.main", // Ensure focus color matches
            //     },
            //   }, // Sets label color to primary
            // }}
          />
        )}
        minDate={xmindate}
        maxDate={xmaxdate}
        // name={xName}
        // className="CmpDatePickerField-v1"
        // style={ { height: '1.3rem!important' } }

        // input={<BootstrapInput />}
        // style={{ height: '2.3rem' }}
      />
      {xError ? (
        <FormHelperText className="text-danger">{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </LocalizationProvider>
  );
};
export const CmpTextFieldV1 = ({
  xSize = "small",
  xTextAlign = "",
  xLabelText = "",
  xVariant = "outlined",
  xValue = "",
  xOnChange,
  xReadOnly = false,
  xType = "text",
  xName = "",
  xOnKeyUp,
  xError,
  xErrorMessage,
  xonFocus,
  xonBlur,
  xtabIndex = "",
  xref = "",
  xDisabled = false,
  xSx = {},
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <TextField
      size={xSize}
      inputProps={{ tabIndex: xtabIndex, style: { textAlign: xTextAlign } }}
      inputRef={xref ? xref : inputReference}
      id={xName}
      label={xLabelText}
      variant={xVariant} //"standard/outlined/filled"
      value={xValue}
      type={xType} // text/number/password
      name={xName}
      className={xReadOnly ? "disable-color test " : "test "}
      InputProps={{
        readOnly: xReadOnly,
      }}
      InputLabelProps={{
        sx: { color: "primary.main" }, // Sets label color to primary
      }}
      onChange={(e) => {
        xOnChange(e);
      }}
      onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
      onFocus={!!xonFocus ? xonFocus : fTextFieldDummy}
      onBlur={!!xonBlur ? xonBlur : fTextFieldDummy}
      fullWidth
      error={xError}
      helperText={xErrorMessage}
      autoComplete="off"
      disabled={xDisabled}
      sx={xSx}
    />
  );
};
export const CmpTextFieldV2 = ({
  xSize = "small",
  xTextAlign = "",
  xLabelText = "",
  xVariant = "outlined",
  xValue = "",
  xOnChange,
  xReadOnly = false,
  xType = "text",
  xName = "",
  xOnKeyUp,
  xError,
  xErrorMessage,
  xonFocus,
  xonBlur,
  xtabIndex = "",
  xref = "",
  xInputProps = {}, // <- add this line
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <TextField
      size={xSize}
      inputProps={{ tabIndex: xtabIndex, style: { textAlign: xTextAlign } }}
      inputRef={xref ? xref : inputReference}
      id={xName}
      label={xLabelText}
      variant={xVariant} //"standard/outlined/filled"
      value={xValue}
      type={xType} // text/number/password
      name={xName}
      className={xReadOnly ? "disable-color test " : "test "}
      InputProps={{
        readOnly: xReadOnly,
        ...xInputProps, // <- merge icon input props here
      }}
      InputLabelProps={{
        sx: { color: "primary.main" }, // Sets label color to primary
      }}
      onChange={(e) => {
        xOnChange(e);
      }}
      onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
      onFocus={!!xonFocus ? xonFocus : fTextFieldDummy}
      onBlur={!!xonBlur ? xonBlur : fTextFieldDummy}
      fullWidth
      error={xError}
      helperText={xErrorMessage}
      autoComplete="off"
    />
  );
};
export const CmpCheckboxFieldV1 = ({
  xChecked,
  xOnChange,
  xDisabled,
  xName,
  xNameField,
  xOnkeyUp,
  xtabIndex = "",
  xref = "",
  xError = false,
  xErrorMessage = "",
  sales_onvoice_check_box = "center",
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <>
      <FormControl
        component="fieldset"
        error={xError}
        className="CmpCheckboxField txt-overflow-ellipse"
      >
        <FormLabel component="legend">{xNameField}</FormLabel>
        <FormGroup>
          <FormControlLabel
            sx={{
              marginRight: "0px",
              textAlign: "center",
              display: "flex",
              justifyContent: sales_onvoice_check_box,
              alignItems: "center",
            }}
            control={
              <Checkbox
                className="d-flex justify-content-center align-items-center foc-text-server-responsive"
                checked={xChecked}
                onChange={xOnChange || fTextFieldDummy}
                onKeyUp={xOnkeyUp || fTextFieldDummy}
                inputProps={{ tabIndex: xtabIndex }}
                inputRef={xref || inputReference}
              />
            }
            name={xName}
            // label={xNameField}
            disabled={xDisabled}
          />
        </FormGroup>
        {xError && (
          <FormHelperText className="danger">{xErrorMessage}</FormHelperText>
        )}
      </FormControl>
    </>
  );
};
export const CmpInputFieldGroupV1 = ({
  xSize = "small",
  xLabelText = "",
  xValue,
  xOnChange = () => {},
  xReadOnly = false,
  xType,
  xName,
  xOnKeyUp = () => {},
  xError,
  xErrorMessage,
  xonFocus,
  xonBlur,
  xtabIndex = "",
  xref = "",
  xTextAlign = "left",
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <>
      <div className="CmpInputFieldGroup">
        <CmpTextFieldV1
          xLabelText={xLabelText}
          xSize={xSize}
          xref={xref}
          xtabIndex={xtabIndex}
          xValue={xValue}
          xType={xType} // text/number/password
          xName={xName}
          xReadOnly={xReadOnly}
          xOnChange={xOnChange}
          xOnKeyUp={xOnKeyUp}
          xError={false}
          xErrorMessage={""}
        />
        <Button
          variant="outlined"
          className="CmpInputFieldGroup-icon"
          onClick={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
          onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
        >
          <MoreHorizIcon />
        </Button>
      </div>
      {xError ? (
        <FormHelperText error={xError}>{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </>
  );
};
export const CmpInputFieldGroup = ({
  xValue,
  xOnChange,
  xReadOnly = false,
  xType,
  xName,
  xOnKeyUp,
  xError,
  xErrorMessage,
  xonFocus,
  xonBlur,
  xtabIndex = "",
  xref = "",
  xTextAlign = "left",
}) => {
  const fTextFieldDummy = () => {};
  const inputReference = useRef(null);
  return (
    <>
      <div className="CmpInputFieldGroup">
        <BootstrapInput
          disabled={xReadOnly}
          inputProps={{ tabIndex: xtabIndex, style: { textAlign: xTextAlign } }}
          inputRef={xref ? xref : inputReference}
          className={xReadOnly ? "disable-color" : ""}
          value={xValue}
          type={xType} // text/number/password
          name={xName}
          readOnly={xReadOnly}
          onChange={(e) => {
            xOnChange(e);
          }}
          onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
          onFocus={!!xonFocus ? xonFocus : fTextFieldDummy}
          onBlur={!!xonBlur ? xonBlur : fTextFieldDummy}
          fullWidth
          autoComplete="off"
        />
        <Button
          variant="outlined"
          className="CmpInputFieldGroup-icon"
          onClick={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
          onKeyUp={!!xOnKeyUp ? xOnKeyUp : fTextFieldDummy}
        >
          <MoreHorizIcon />
        </Button>
      </div>
      {xError ? (
        <FormHelperText error={xError}>{xErrorMessage}</FormHelperText>
      ) : (
        ""
      )}
    </>
  );
};

export const CmpBtnCard = ({ Status }) => {
  return (
    <Button
      size="small"
      style={{
        background:
          Status == "POST" ? "green" : Status == "ENTER" ? "yellow" : "red",
        borderRadius: "20px",
        padding: "1px 6px",
        color: "black",
        textTransform: "none",
        minWidth: "-webkit-fill-available",
        border: "1px solid lightgray",
        fontSize: "10px",
        fontWeight: "bolder",
      }}
    >
      {Status}
    </Button>
  );
};
